import { CellContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { Stack } from 'src/core/ui';

import { BaseCell, BaseCellProps } from './BaseCell';
import * as styles from './IconTextCell.css';

export interface IconTextCellValue {
  text?: ReactNode;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
}

export interface IconTextCellProps<TData = unknown>
  extends IconTextCellValue, Omit<BaseCellProps, 'children'> {
  cellStyle?: React.CSSProperties;
  context?: CellContext<TData, IconTextCellValue>;
}

export function IconTextCell<TData>({
  context,
  cellStyle,
  text,
  iconLeft,
  iconRight,
  ...props
}: IconTextCellProps<TData>) {
  const value = context?.getValue() || {
    text: text,
    iconLeft: iconLeft,
    iconRight: iconRight,
  };

  if (!value) return <BaseCell {...props} />;

  return (
    <BaseCell isFullWidth={Boolean(value.iconRight)} {...props}>
      <Stack
        justifyContent="spaceBetween"
        alignItems="center"
        style={{ width: '100%', ...cellStyle }}
      >
        <Stack
          gap={'s'}
          alignItems="center"
          style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}
        >
          {value.iconLeft && (
            <span className={styles.icon}>{value.iconLeft}</span>
          )}
          <span className={styles.text}>{value.text}</span>
        </Stack>
        {value.iconRight && (
          <span className={styles.iconRight}>{value.iconRight}</span>
        )}
      </Stack>
    </BaseCell>
  );
}
